<button
  [type]="type"
  (mouseenter)="mouseEntered.emit($event)"
  (mouseleave)="mouseLeft.emit($event)"
  (focus)="handleFocus($event)"
  (blur)="handleBlur($event)"
  (click)="clicked.emit($event)"
  [disabled]="disabled"
  [title]="ariaLabel ?? ''"
  [attr.role]="ariaRole"
  [attr.aria-label]="ariaLabel"
  [attr.aria-description]="ariaDescription"
  [attr.aria-haspopup]="ariaHasPopup"
  [attr.aria-expanded]="ariaExpanded"
  [attr.aria-controls]="ariaControls"
  [attr.aria-owns]="ariaOwns"
  [attr.aria-activedescendant]="ariaActiveDescendant"
  [attr.aria-selected]="ariaSelected"
  [attr.aria-pressed]="ariaPressed"
  [attr.aria-invalid]="ariaInvalid"
  [attr.id]="buttonId"
  [ngClass]="{
    primary: primary,
    secondary: secondary,
    text: text,
    lg: size === 'lg',
    sm: size === 'sm',
    xs: size === 'xs',
  }"
  [class]="buttonClass ?? ''"
  [ngStyle]="
    generateStyle({
      color: secondary
        ? (backgroundColor | contrastColor)
        : disabled
          ? disabledColor
          : baseColor,
      backgroundColor: backgroundColor,
      borderColor: disabled ? disabledColor : baseColor,
      boxShadow: btnFocused && !disabled ? boxShadow : 'none',
    })
  "
  #button
>
  <div><ng-content /></div>
</button>
